<template>
  <nav
    :aria-label="i18n(translations.mainNavigationAriaLabel)"
    class="bg-surface-default-low h-48 transition-colors"
  >
    <div class="flex h-full items-center justify-center gap-60">
      <div class="grid h-full min-w-0">
        <div
          class="relative pointer-events-none z-[1] col-start-1 row-start-1"
          :class="[
            !arrivedState.left
              ? `before:from-bg-static-default-low before:absolute before:inset-y-0 before:left-0 before:h-48 before:w-32 before:bg-gradient-to-r before:to-transparent before:content-['']`
              : '',
            !arrivedState.right
              ? `after:from-bg-static-default-low after:absolute after:inset-y-0 after:right-0 after:h-48 after:w-32 after:bg-gradient-to-l after:to-transparent after:content-['']`
              : '',
          ]"
        ></div>
        <ul
          ref="menu"
          class="col-start-1 row-start-1 -mb-4 flex flex-row items-center gap-32 overflow-auto p-4 scrollbar-none"
        >
          <NavMenuItem
            v-for="(item, index) in items"
            :key="item.id"
            class="h-full"
            v-bind="item"
            :position="index"
          />
        </ul>
      </div>

      <NavServicesMenu
        v-if="isNavigationServicesRevampEnabled"
        class="shrink-0"
      />
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useScroll } from '@vueuse/core'

import { useFetchNavigationItems } from '../../composables/useFetchNavigationItems'

import translations from './NavMenu.translations'
import NavMenuItem from './NavMenuItem.vue'
import NavServicesMenu from './NavServicesMenu.vue'

const menu = ref()
const { arrivedState } = useScroll(menu)
const i18n = useI18n()

const { items } = useFetchNavigationItems()

const experiments = useExperiments()
const isNavigationServicesRevampEnabled = computed(
  () => experiments['experiment.navigationServicesRevamp'] === 'withServices',
)
</script>
